// Common
import config from '@/config.js';

// let baseURL = "http://api.new.com/";// 本地测试环境接口域名
let baseURL = "https://test.api.ent.yywd.vip/";// 云端测试环境接口域名
// let baseURL = "https://api.v1.yywd.vip/";// 正式服
if (window.location.host.startsWith('ent.yywd.vip')) {
    config.debug = false;
    baseURL = "https://api.v1.yywd.vip/";// 生产环境接口域名
} else if (window.location.host.startsWith('entvue.jicainiao.com')) {
    config.debug = false;
    baseURL = 'https://api.ent.jicainiao.com/' // 三联独立部署接口域名
} else if (window.location.host.startsWith('entvue2.jicainiao.com')) {
    config.debug = false;
    baseURL = 'https://api.ent2.jicainiao.com/' // 三联独立部署接口域名
} else if (window.location.host.startsWith('test.ent.yywd.vip')) {
    config.debug = false;
    baseURL = "https://test.api.ent.yywd.vip/";// 云端测试环境接口域名
} else if (window.location.host.startsWith('branch.ent.yywd.vip')) {
    config.debug = false;
    baseURL = "https://branch.api.ent.yywd.vip/";// 云端测试环境接口域名
} else if (window.location.host.startsWith('beta.ent.yywd.vip')) {
  config.debug = false
  baseURL = "https://beta.api.ent.yywd.vip/";// 云端测试环境接口域名
} else if (window.location.host.startsWith('tmp.ent.yywd.vip')) {
  config.debug = false
  baseURL = "https://tmp.api.ent.yywd.vip/";// 云端测试环境接口域名
}

const Headers = {
    debug: false,//for test
    "request-from": "EnterpriseAdmin",
};

export default {
    BaseURL: baseURL,
    // OldPlatform: oldPlatform,
    Headers
}